import apiService from './apiService';

const unwrap = (response) => response?.data;
const errMsg = (error, fallback) =>
  error?.response?.data?.error || error?.response?.data?.message || fallback;

class OutboundCampaignService {
  async list(params = {}) {
    try {
      const qs = new URLSearchParams();
      if (params.status) qs.append('status', params.status);
      if (params.limit) qs.append('limit', params.limit);
      if (params.offset) qs.append('offset', params.offset);
      const endpoint = `outbound-campaigns${qs.toString() ? `?${qs}` : ''}`;
      const body = unwrap(await apiService.apiRequest('get', endpoint));
      return { success: !!body?.success, data: body?.data || [], total: body?.total || 0 };
    } catch (error) {
      return { success: false, message: errMsg(error, '取得活動列表失敗'), data: [], total: 0 };
    }
  }

  async get(id) {
    try {
      const body = unwrap(await apiService.apiRequest('get', `outbound-campaigns/${id}`));
      return { success: !!body?.success, data: body?.data };
    } catch (error) {
      return { success: false, message: errMsg(error, '取得活動失敗') };
    }
  }

  async create(data) {
    try {
      const body = unwrap(await apiService.apiRequest('post', 'outbound-campaigns', data));
      return { success: !!body?.success, data: body?.data, message: body?.error };
    } catch (error) {
      return { success: false, message: errMsg(error, '建立活動失敗') };
    }
  }

  async uploadContacts(id, file) {
    try {
      const form = new FormData();
      form.append('file', file);
      const body = unwrap(await apiService.apiRequest(
        'post',
        `outbound-campaigns/${id}/contacts/upload`,
        form
      ));
      return { success: !!body?.success, data: body?.data, message: body?.error };
    } catch (error) {
      return { success: false, message: errMsg(error, '上傳聯絡人失敗') };
    }
  }

  async listContacts(id, params = {}) {
    try {
      const qs = new URLSearchParams();
      if (params.status) qs.append('status', params.status);
      if (params.limit) qs.append('limit', params.limit);
      if (params.offset) qs.append('offset', params.offset);
      const endpoint = `outbound-campaigns/${id}/contacts${qs.toString() ? `?${qs}` : ''}`;
      const body = unwrap(await apiService.apiRequest('get', endpoint));
      return { success: !!body?.success, data: body?.data || [], total: body?.total || 0 };
    } catch (error) {
      return { success: false, message: errMsg(error, '取得聯絡人失敗'), data: [], total: 0 };
    }
  }

  async start(id) {
    try {
      const body = unwrap(await apiService.apiRequest('post', `outbound-campaigns/${id}/start`));
      return { success: !!body?.success, data: body?.data, message: body?.error };
    } catch (error) {
      return { success: false, message: errMsg(error, '開始撥打失敗') };
    }
  }

  exportCsvUrl(id) {
    return `outbound-campaigns/${id}/export`;
  }
}
// (note: voice-flow regen API lives in voiceFlowService, not here)

const service = new OutboundCampaignService();
export default service;
